import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function SyncDevicesPage() {
  const syncUrl =
    import.meta.env.VITE_DEVICE_SYNC_URL ??
    "https://api.iskconpunebcec.com/admin/devices";

  return (
    <div className="mx-auto max-w-lg space-y-4">
      <div>
        <h2 className="text-2xl font-semibold">Sync device users</h2>
        <p className="text-sm text-muted-foreground">
          Push updated people and PINs to biometric terminals.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-base">Device management</CardTitle>
          <CardDescription>
            After adding or editing people, sync users to all registered
            fingerprint/face devices so punches match the portal.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button asChild>
            <a href={syncUrl} target="_blank" rel="noopener noreferrer">
              Open device sync console
            </a>
          </Button>
          <p className="text-sm text-muted-foreground">
            This opens the backend device sync UI. Ensure people are saved here
            first, then run sync from the console.
          </p>
          <Button variant="outline" asChild>
            <Link to="/admin/people">Manage people</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
